import SEOHead, { injectBaseSchema } from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import LatestUpdates from './components/LatestUpdates';
import RankingSection from './components/RankingSection';
import CategoryGrid from './components/CategoryGrid';
import ReviewGrid from './components/ReviewGrid';
import CTASection from './components/CTASection';
import { useEffect } from 'react';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '韩漫之家 - 免费韩漫大全',
  description: '免费韩漫大全，支持韩国漫画下拉式在线阅读，经典到新作一应俱全。',
  url: 'http://uyeqdpvovrg.cn/',
  isPartOf: {
    '@type': 'WebSite',
    name: '韩漫之家',
    url: 'http://uyeqdpvovrg.cn/',
  },
  mainEntity: {
    '@type': 'ItemList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '热血漫画', url: 'http://uyeqdpvovrg.cn/category/rexue' },
      { '@type': 'ListItem', position: 2, name: '恋爱漫画', url: 'http://uyeqdpvovrg.cn/category/lianai' },
      { '@type': 'ListItem', position: 3, name: '奇幻漫画', url: 'http://uyeqdpvovrg.cn/category/qihuan' },
      { '@type': 'ListItem', position: 4, name: '悬疑漫画', url: 'http://uyeqdpvovrg.cn/category/xuanyi' },
      { '@type': 'ListItem', position: 5, name: '搞笑漫画', url: 'http://uyeqdpvovrg.cn/category/gaoxiao' },
      { '@type': 'ListItem', position: 6, name: '校园漫画', url: 'http://uyeqdpvovrg.cn/category/xiaoyuan' },
    ],
  },
};

export default function Home() {
  useEffect(() => {
    injectBaseSchema();
  }, []);

  return (
    <>
      <SEOHead
        title="免费韩漫-韩漫大全-韩国漫画下拉式在线阅读-韩漫之家"
        description="韩漫之家汇集免费韩漫大全，支持韩国漫画下拉式在线阅读，您可轻松翻阅大量作品，从经典到新作一应俱全，满足您对韩漫的所有期待与热爱。热血、恋爱、奇幻、悬疑、搞笑等全类型覆盖。"
        keywords="免费韩漫,韩漫大全,韩国漫画下拉式,韩漫之家,韩漫在线阅读,免费韩国漫画"
        canonicalUrl="http://uyeqdpvovrg.cn/"
        ogTitle="免费韩漫-韩漫大全-韩国漫画下拉式在线阅读-韩漫之家"
        ogDescription="韩漫之家汇集免费韩漫大全，支持韩国漫画下拉式在线阅读，从经典到新作一应俱全。"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <LatestUpdates />
        <RankingSection />
        <CategoryGrid />
        <ReviewGrid />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}